import { render } from "./OptionList.vue?vue&type=template&id=450dba48&scoped=true"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"

import "./OptionList.vue?vue&type=style&index=0&id=450dba48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450dba48"]])

export default __exports__